import { Box, Button, Checkbox, createTheme, Dialog, DialogActions, FormControl, FormControlLabel, InputLabel, MenuItem, Select, TextField, ThemeProvider } from '@mui/material';

import { DialogTitle, Typography, withStyles } from '@material-ui/core';

import { withRouter } from 'react-router-dom';

import React, { useEffect, useState } from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { TOAST_MESSAGE_SEVERITY_ERROR, TOAST_MESSAGE_SEVERITY_SUCCESS } from 'modules/layout/types';
import { showToast } from 'modules/layout/layout.actions';
import Spinner from 'modules/common/spinner.component';
import { COLOR_PRIMARY, COLOR_SECONDARY, COLOR_WARNING } from 'styles/theme';
import { postVendor } from 'modules/authorizations/authorizations.actions';
import { POST_VENDORS_SUCCESS } from 'modules/authorizations/types';
import GoogleAddressSearch from 'modules/common/googleAddressSearch.component';

const styles = theme => ({
    wideControl: {
        minWidth: 174
    },
    section: {
        marginBottom: theme.spacing(2)
    }
});

const CreateVendorDialog = props => {
    const { provincesEnum, vendorStatuses, vendorTypes, classes } = props;

    const theme = createTheme({
        palette: {
            primary: COLOR_PRIMARY,
            secondary: COLOR_SECONDARY,
            warning: COLOR_WARNING
        }
    });

    const [isLoadingModal, setIsLoadingModal] = useState(false);
    const [isDirty, setIsDirty] = useState(false);

    // Main vendor fields
    const [newCompanyName, setNewCompanyName] = useState('');
    const [newDescription, setNewDescription] = useState('');
    const [newVendorCode, setNewVendorCode] = useState('');
    const [newStatusId, setNewStatusId] = useState(null);
    const [newVendorTypeId, setNewVendorTypeId] = useState(null);
    const [newOfficePhone, setNewOfficePhone] = useState('');
    const [newOfficeEmail, setNewOfficeEmail] = useState('');
    const [newBankingRequired, setNewBankingRequired] = useState(false);

    // Primary Address fields
    const [editedAddress, setEditedAddress] = useState({
        addressLine1: '',
        addressLine2: '',
        addressLine3: '',
        city: '',
        county: '',
        countryId: null,
        provinceId: null,
        zipcode: ''
    });
    //   const [newAddressLineOne, setNewAddressLineOne] = useState('');
    //   const [newAddressLineTwo, setNewAddressLineTwo] = useState('');
    //   const [newAddressLineThree, setNewAddressLineThree] = useState('');
    //   const [newCity, setNewCity] = useState('');
    //   const [newCounty, setNewCounty] = useState('');
    //   const [newCountryId, setNewCountryId] = useState(null);
    //   const [newProvinceId, setNewProvinceId] = useState(null);
    //   const [newZip, setNewZip] = useState('');

    const createVendor = async () => {
        setIsLoadingModal(true);

        const basicAuthInfo = {
            vendorRecord: {
                companyName: newCompanyName,
                vendorTypeId: newVendorTypeId,
                statusId: newStatusId,
                contractDate: new Date(),
                contractExpires: new Date(),
                statusUpdated: new Date(),
                description: newDescription,
                vendorCode: newVendorCode,
                officePhone: newOfficePhone,
                officeEmail: newOfficeEmail,
                companyWebsite: '',
                slaRelief: '',
                commissions: '',
                hasBankingInformationRequired: newBankingRequired,
                taxesId: 0,
                terms: '',
                from1099: '',
                box1099: '',
                checkAmount: '',
                seOrgUid: '',
                apTrackingCR: '',
                addedBy: 1,
                addedOn: new Date(),
                modifiedBy: 1,
                modifiedOn: new Date()
            },
            address: {
                ...editedAddress,
                addressTypeId: 'b530b48e-6f25-4356-8d7b-70efb5a8005e',
                addedBy: 1,
                addedOn: new Date(),
                modifiedBy: 1,
                modifiedOn: new Date()
            },
        }

        const postVendorResp = await props.postVendor(basicAuthInfo);
        if (postVendorResp.type === POST_VENDORS_SUCCESS) {
            props.showToast('Successfully created new vendor!', { severity: TOAST_MESSAGE_SEVERITY_SUCCESS });
            props.onCancel();
        } else {
            props.showToast('Failed to create vendor, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
        }

        setIsLoadingModal(false);
    }

    useEffect(() => {
        if (newCompanyName.length === 0 || newDescription.length === 0 || newOfficeEmail.length === 0 || newOfficePhone.length === 0 || newBankingRequired === null ||
            newStatusId === null || newVendorTypeId === null || editedAddress.addressLine1.length === 0 || editedAddress.countryId === null || editedAddress.zipcode.length === 0 || editedAddress.provinceId === null
            || editedAddress.city.length === 0 || editedAddress.county.length === 0) {
            setIsDirty(true);
        } else {
            setIsDirty(false);
        }
    }, [newCompanyName, newDescription, newOfficeEmail, newOfficePhone, newStatusId, newVendorTypeId, newBankingRequired,
        editedAddress
    ]);

    return (
        <ThemeProvider theme={theme}>
            <Dialog open={props.open} fullWidth={false} maxWidth={'lg'}>
                <DialogTitle>New Partner</DialogTitle>
                <Box sx={{ display: 'flex', flexDirection: 'row', padding: '20px', flexWrap: 'wrap', gap: '20px' }}>
                    <Box>
                        <TextField
                            key={'newCompanyName'}
                            label={'Company Name'}
                            name={'cnewCompanyName'}
                            required={true}
                            variant="outlined"
                            sx={{ maxWidth: '360px' }}
                            value={newCompanyName}
                            onChange={(e) => setNewCompanyName(e.target.value)}
                            type="text"
                            InputLabelProps={{ shrink: true }}
                        />
                        <Typography variant="caption" display="block" color="primary">
                            Required
                        </Typography>
                    </Box>
                    <Box>
                        <TextField
                            key={'newDescription'}
                            label={'Description'}
                            name={'newDescription'}
                            value={newDescription}
                            variant="outlined"
                            required={false}
                            sx={{ maxWidth: '360px' }}
                            type="text"
                            onChange={(e) => setNewDescription(e.target.value)}
                            InputLabelProps={{ shrink: true }}
                        />
                    </Box>
                    <Box>
                        <TextField
                            key={'newVendorCode'}
                            label={'Partner Code'}
                            name={'newVendorCode'}
                            value={newVendorCode}
                            variant="outlined"
                            required={false}
                            sx={{ maxWidth: '360px' }}
                            type="text"
                            onChange={(e) => setNewVendorCode(e.target.value)}
                            InputLabelProps={{ shrink: true }}
                        />
                    </Box>
                    <Box>
                        <FormControl sx={{ marginTop: '6px' }}>
                            <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }} id={'vendorTypeId'}>
                                Partner Type
                            </InputLabel>
                            <Select
                                labelId={'newVendorTypeId'}
                                key={'newVendorTypeId'}
                                label={'newVendorTypeId'}
                                name={'newVendorTypeId'}
                                required={true}
                                disabled={false}
                                value={newVendorTypeId}
                                margin="dense"
                                variant="standard"
                                sx={{ marginTop: '6px', marginBottom: '6px', maxWidth: '360px', minWidth: '180px' }}
                                onChange={e => setNewVendorTypeId(e.target.value)}
                            >
                                {vendorTypes.map(opt => (
                                    <MenuItem key={opt.id} value={opt.id} sx={{ margin: 'dense' }} disabled={false}>
                                        {opt.title}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <Typography variant="caption" display="block" color="primary">
                            Required
                        </Typography>
                    </Box>
                    <Box>
                        <FormControl sx={{ marginTop: '6px' }}>
                            <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }} id={'newStatusId'}>
                                Status
                            </InputLabel>
                            <Select
                                labelId={'newStatusId'}
                                key={'newStatusId'}
                                label={'newStatusId'}
                                name={'newStatusId'}
                                required={true}
                                disabled={false}
                                value={newStatusId}
                                margin="dense"
                                variant="standard"
                                sx={{ marginTop: '6px', marginBottom: '6px', maxWidth: '360px', minWidth: '180px' }}
                                onChange={e => setNewStatusId(e.target.value)}
                            >
                                {vendorStatuses.map(opt => (
                                    <MenuItem key={opt.id} value={opt.id} sx={{ margin: 'dense' }} disabled={false}>
                                        {opt.title}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <Typography variant="caption" display="block" color="primary">
                            Required
                        </Typography>
                    </Box>
                    <Box>
                        <TextField
                            key={'newOfficePhone'}
                            label={'Office Phone'}
                            name={'newOfficePhone'}
                            value={newOfficePhone}
                            required={false}
                            sx={{ maxWidth: '360px' }}
                            variant="outlined"
                            onChange={(e) => setNewOfficePhone(e.target.value)}
                            type="text"
                            InputLabelProps={{ shrink: true }}
                        />
                        <Typography variant="caption" display="block" color="primary">
                            Required
                        </Typography>
                    </Box>
                    <Box>
                        <TextField
                            key={'newOfficeEmail'}
                            label={'Office Email'}
                            name={'newOfficeEmail'}
                            value={newOfficeEmail}
                            required={false}
                            sx={{ maxWidth: '360px' }}
                            variant="outlined"
                            onChange={(e) => setNewOfficeEmail(e.target.value)}
                            type="text"
                            InputLabelProps={{ shrink: true }}
                        />
                        <Typography variant="caption" display="block" color="primary">
                            Required
                        </Typography>
                    </Box>
                    <Box>
                        <FormControl sx={{ marginTop: '20px', marginBottom: '1px' }}>
                            <FormControlLabel
                                key={'newBankingRequired'}
                                name={'newBankingRequired'}
                                label={'Banking Info Required'}
                                labelPlacement="start"
                                control={<Checkbox />}
                                required={false}
                                disabled={false}
                                checked={newBankingRequired}
                                variant="standard"
                                margin="dense"
                                sx={{ marginTop: '6px', minWidth: '120px', maxWidth: '360px' }}
                                onClick={(e) => setNewBankingRequired(e.target.checked ? true : false)}
                            />
                        </FormControl>
                    </Box>
                </Box>

                <Box sx={{ height: '2px', backgroundColor: '#ccc', margin: '20px 0' }} />
                <div>
                    <GoogleAddressSearch
                        address={editedAddress}
                        provinces={provincesEnum}
                        countries={props.countriesEnum}
                        classes={classes}
                        onChange={e => {
                            setEditedAddress(e);
                        }}
                    />
                </div>

                {/* <Box sx={{ display: 'flex', flexDirection: 'row', padding: '20px', flexWrap: 'wrap', gap: '20px' }}>
                <Box>
                    <TextField
                        key={'newAddressLineOne'}
                        label={'Address Line 1'}
                        name={'newAddressLineOne'}
                        required={false}
                        disabled={false}
                        value={newAddressLineOne}
                        sx={{ maxWidth: '360px' }}
                        margin="dense"
                        variant="standard"
                        onChange={(e) => setNewAddressLineOne(e.target.value)}
                    />
                    <Typography variant="caption" display="block" color="primary">
                        Required
                    </Typography>
                </Box>
                <Box>
                    <TextField
                        key={'newAddressLineTwo'}
                        label={'Address Line 2'}
                        name={'newAddressLineTwo'}
                        required={false}
                        disabled={false}
                        value={newAddressLineTwo}
                        sx={{ maxWidth: '360px' }}
                        margin="dense"
                        variant="standard"
                        onChange={(e) => setNewAddressLineTwo(e.target.value)}
                    />
                </Box>
                <Box>
                    <TextField
                        key={'newAddressLineThree'}
                        label={'Address Line 3'}
                        name={'newAddressLineThree'}
                        required={false}
                        disabled={false}
                        value={newAddressLineThree}
                        sx={{ maxWidth: '360px' }}
                        margin="dense"
                        variant="standard"
                        onChange={(e) => setNewAddressLineThree(e.target.value)}
                    />
                </Box>
                <Box>
                    <TextField
                        key={'newCity'}
                        label={'City'}
                        name={'newCity'}
                        required={false}
                        disabled={false}
                        value={newCity}
                        sx={{ maxWidth: '360px' }}
                        margin="dense"
                        variant="standard"
                        onChange={(e) => setNewCity(e.target.value)}
                    />
                    <Typography variant="caption" display="block" color="primary">
                        Required
                    </Typography>
                </Box>
                <Box>
                    <TextField
                        key={'newCounty'}
                        label={'County'}
                        name={'newCounty'}
                        required={false}
                        disabled={false}
                        value={newCounty}
                        sx={{ maxWidth: '360px' }}
                        margin="dense"
                        variant="standard"
                        onChange={(e) => setNewCounty(e.target.value)}
                    />
                    <Typography variant="caption" display="block" color="primary">
                        Required
                    </Typography>
                </Box>
                <Box>
                    <FormControl sx={{ marginTop: '6px' }}>
                        <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }} id={'newCountryId'}>
                            Country
                        </InputLabel>
                        <Select
                            labelId={'newCountryId'}
                            key={'newCountryId'}
                            label={'newCountryId'}
                            name={'newCountryId'}
                            required={true}
                            disabled={false}
                            value={newCountryId}
                            margin="dense"
                            variant="standard"
                            sx={{ marginTop: '6px', marginBottom: '6px', maxWidth: '360px', minWidth: '180px' }}
                            onChange={e => setNewCountryId(e.target.value)}
                        >
                            {countriesEnum.sort((a, b) => a.title.localeCompare(b.title)).map(opt => (
                                <MenuItem key={opt.id} value={opt.id} sx={{ margin: 'dense' }} disabled={false}>
                                    {opt.title} 
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <Typography variant="caption" display="block" color="primary">
                        Required
                    </Typography>
                </Box>
                <Box>
                    <FormControl sx={{ marginTop: '6px' }}>
                        <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }} id={'newProvinceId'}>
                           State / Province
                        </InputLabel>
                        <Select
                            labelId={'newProvinceId'}
                            key={'newProvinceId'}
                            label={'newProvinceId'}
                            name={'newProvinceId'}
                            required={true}
                            disabled={newCountryId == null}
                            value={newProvinceId}
                            margin="dense"
                            variant="standard"
                            sx={{ marginTop: '6px', marginBottom: '6px', maxWidth: '360px', minWidth: '180px' }}
                            onChange={e => setNewProvinceId(e.target.value)}
                        >
                            {newCountryId && provincesEnum.sort((a, b) => a.title.localeCompare(b.title)).filter((pe) => pe.countryId === newCountryId).map(opt => (
                                <MenuItem key={opt.id} value={opt.id} sx={{ margin: 'dense' }} disabled={false}>
                                    {opt.title} 
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <Typography variant="caption" display="block" color="primary">
                        Required
                    </Typography>
                </Box>
                <Box>
                    <TextField
                        key={'newZip'}
                        label={'Zip Code'}
                        name={'newZip'}
                        required={false}
                        disabled={false}
                        value={newZip}
                        sx={{ maxWidth: '360px' }}
                        margin="dense"
                        variant="standard"
                        onChange={(e) => setNewZip(e.target.value)}
                    />
                    <Typography variant="caption" display="block" color="primary">
                        Required
                    </Typography>
                </Box>
            </Box> */}
                <DialogActions sx={{ p: '1.25rem' }}>
                    {isLoadingModal && <Spinner />}
                    {!isLoadingModal && (
                        <>
                            <Button onClick={() => props.onCancel()}>Cancel</Button>
                            <Button
                                onClick={createVendor}
                                color="primary"
                                type="submit"
                                variant="contained"
                                disabled={isDirty}
                            >
                                Create Partner
                            </Button>
                        </>
                    )}
                </DialogActions>
            </Dialog>
        </ThemeProvider>
    );
};

const mapStateToProps = state => {
    const { countries, provinces, vendorTypes, vendorStatuses, addressTypes } = state.enumerations.allEnums;

    return {
        countriesEnum: countries,
        provincesEnum: provinces,
        vendorStatuses: vendorStatuses,
        vendorTypes: vendorTypes,
        addressTypes: addressTypes,

    };
};

export default compose(
    withStyles(styles),
    withRouter,
    connect(mapStateToProps, {
        postVendor,
        showToast
    }),
)(CreateVendorDialog);
